import subjectGrading from '@/api/subject-grading-range'
import mainProgram from '@/api/main-program'
import subProgram from '@/api/sub-program'
import level from '@/api/level'
import grade from '@/api/grade'
import gDefinition from '@/api/grading-definition'

import { baseState, baseMutations } from '@/store/mixins'

export const state = {
  ...baseState,
  score_version_id: null
}

export const getters = {}

export const mutations = {
  ...baseMutations,
  SET_SCORE_VERSION_ID(state, data) {
    state.score_version_id = data
  }
}

export const actions = {
  fetch(context, attributes = {}) {
    const params = Object.assign(
      {
        page: context.state.pagination.page,
        perPage: context.state.pagination.perPage,
        search: context.state.search,
        filter: {
          score_version_id: context.state.score_version_id
        }
      },
      attributes
    )

    return subjectGrading.get({ params }).then(response => {
      context.commit('RECEIVE_RESOURCES', response)
      return Promise.resolve(response)
    })
  },

  store(context, data) {
    return subjectGrading.store(data)
  },

  async find(context, id) {
    if (_.isEmpty(context.state.edit_data)) {
      let response = await subjectGrading.find(id)
      context.commit('SET_EDIT_DATA', response.data)
    }
  },

  update(context, { id, data }) {
    return subjectGrading.update(id, data)
  },
  getMainProgram(context) {
    return mainProgram.get({
      params: {
        fields: {
          academic_program_mains: 'acp_id,acp_name_foreign'
        },
        page: -1
      },
      header: {
        'X-PERMISSION-ALLOW-CODE': context.rootGetters.permissionAllowCode
      }
    })
  },
  getSubProgram(context, acp_id) {
    return subProgram.get({
      params: {
        fields: {
          academic_program_subs: 'acps_id,acps_name_foreign'
        },
        filter: {
          acp_id: acp_id
        },
        page: -1
      },
      header: {
        'X-PERMISSION-ALLOW-CODE': context.rootGetters.permissionAllowCode
      }
    })
  },
  getLevel(context, acps_id) {
    return level.get({
      params: {
        fields: {
          academic_program_levels: 'level_id,level_name_foreign'
        },
        filter: {
          acps_id: acps_id
        },
        page: -1
      },
      header: {
        'X-PERMISSION-ALLOW-CODE': context.rootGetters.permissionAllowCode
      }
    })
  },
  getGrade(context, level_id) {
    return grade.get({
      params: {
        fields: {
          academic_program_level_grades: 'grade_id,grade_name_foreign'
        },
        'filter[academic_program_level_grades.level_id]': level_id,
        page: -1
      },
      header: {
        'X-PERMISSION-ALLOW-CODE': context.rootGetters.permissionAllowCode
      }
    })
  },
  getSubject(context, grade_id) {
    return grade.get({
      params: {
        include: 'grade_subjects',
        fields: {
          academic_program_level_grades: 'grade_id,grade_name_foreign'
        },
        filter: {
          grade_id: grade_id
        },
        page: -1
      },
      header: {
        'X-PERMISSION-ALLOW-CODE': context.rootGetters.permissionAllowCode
      }
    })
  },
  getGradingDefinition(context, acps_id) {
    return gDefinition.get({
      params: {
        fields: {
          score_grading_definitions:
            'grade_definition_id,grade,definition_name_en,definition_type,grade'
        },
        filter: {
          acps_id: acps_id
        },
        page: -1
      },
      header: {
        'X-PERMISSION-ALLOW-CODE': context.rootGetters.permissionAllowCode
      }
    })
  },
  getSubjectGradingCreated(context) {
    return subjectGrading.get({
      params: {
        include: 'grade_subject',
        fields: {
          grade_subject: 'grade_subject_id,subject_id',
          academic_grade_subject_grading_range: 'grade_subject_id'
        },
        page: -1
      },
      header: {
        'X-PERMISSION-ALLOW-CODE': context.rootGetters.permissionAllowCode
      }
    })
  },
  getEditData(context, grade_subject_id) {
    return subjectGrading.get({
      params: {
        filter: {
          grade_subject_id: grade_subject_id
        },
        perPage: -1
      }
    })
  },
  getScoreVersions() {
    return grade.getScoringVersions({ params: { page: -1 } })
  }
}
